import { utils, write, writeFile } from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportToExcelFun = (json, name) => {
    const worksheet = utils.json_to_sheet(json);

    var wscols = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 10 },
        { width: 20 },
        { width: 8 },
        { width: 20 },
        { width: 20 },
    ];

    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    worksheet["!cols"] = wscols;
    writeFile(workbook, name + "_" + new Date().toLocaleString().replace(/-/g, '_').replace(/ /g, '_').replace(/[\/]/g, '_') + ".xlsx");
};

export const exportToExcelFunTwo = async () => {
    const json = [
        {
            name: "ABC",
            Age: 26
        },
        {
            name: "ABCD",
            Age: 24
        }
    ];
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Define custom column widths
    worksheet.columns = [
        { key: 'name', width: 20 },
        { key: 'Age', width: 10 }
    ];

    worksheet.getRow(0).font = { name: 'Comic Sans MS', family: 4, size: 16, bold: true, }

    // Define a style for the header row with a red background color and bold font
    const headerStyle = {
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFF0000' }, // Red background color
        },
        font: {
            bold: true,
            color: { argb: 'FFFFFFFF' }, // White font color
            size: 14,
        },
        alignment: {
            vertical: 'middle', horizontal: 'center'
        }
    };

    // Add header row
    const headerRow = worksheet.addRow(Object.keys(json[0]));
    headerRow.eachCell((cell) => {
        cell.style = headerStyle;
    });
    headerRow.height = 30;
    // Add data rows
    json.forEach((rowData) => {
        worksheet.addRow(Object.values(rowData));
    });

    // Generate Excel file
    const excelBuffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    saveAs(blob, 'data.xlsx');
};